export default __webpack_public_path__ + "afde17fb615e9beace469611a8aae62b.svg";